import { Box, Modal, Stack, Typography } from '@mui/material';
import semver from 'semver';

import useGetUpdateVersion from '@/app/useGetUpdateVersion';
import LookoButton from '@/components/LDS/LookoButton';

const style = {
  position: 'absolute',
  width: 440,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
};

/**
 * 강제 업데이트 - 리로드
 */
export default function UpdateVersionModal() {
  const { data } = useGetUpdateVersion();
  const updateVersion = data?.appVersion?.web ?? '';

  if (!semver.valid(updateVersion)) {
    return null;
  }

  return (
    <Modal open={semver.lt(_APP_VERSION, updateVersion)}>
      <Box sx={style}>
        <Stack spacing={1}>
          <Stack spacing={1} px={3} pt={3} pb={1}>
            <Typography variant="Title_Looko">서비스 업데이트로 브라우저의 새로고침이 필요합니다.</Typography>
            <Typography variant="Body_Looko">F5 키를 누르시거나, 우측의 새로고침 버튼을 눌러주세요. </Typography>
          </Stack>
          <Stack direction={'row'} justifyContent={'flex-end'} px={2} py={1}>
            <LookoButton variant="text" title={'새로고침'} onClick={() => window.location.reload()} />
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
}
